import React from 'react'
import './RightContent.css'

const RightContent = ({ children }) => {
    return (
        <div className='rightcontent'>
            {children}
        </div>
    )
}

export default RightContent